<template>
  <v-container>
    <h2>FAQ</h2>
    <v-list>
      <v-list-group
        v-for="(item, index) in items"
        :key="index"
        append-icon="mdi-menu-up"
        no-action
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title v-text="item.question"></v-list-item-title>
          </v-list-item-content>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title v-text="item.answer"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-container>
</template>

<script>
export default {
  name: "Help",
  computed: {
    items() {
      return this.$appConfig.assets.data.faq.map(e => ({ question: e[0], answer: e[1] }))
    }
  }
}
</script>
